import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { addDoc, collection, setDoc, doc } from 'firebase/firestore';

import { db } from '../../utils/firebase-config';
import { Loader } from '../../components';
import { MarkdownEditor, EditorTextInput } from '../../components';

export const PostConfigView = ({ fetchPostDetail, loadingPostDetail, postDetail }) => {
    const navigate = useNavigate();
    const { uuid = '' } = useParams();

    useEffect(() => {
        if (uuid) fetchPostDetail(uuid);
    }, []);

    const handleOnSubmit = async (evt) => {
        evt.preventDefault();
        const formData = new FormData(evt.target);
        const editorValue = formData.get('editor');
        const textValue = formData.get('title');
        const isDraft = evt?.nativeEvent?.submitter?.id === 'saveAsDraft';

        if (editorValue && textValue) {
            uuid ? await setDoc(doc(db, 'blog-data', String(uuid)), {
                title: textValue,
                description: editorValue,
                isDraft
            }).then(() => {
                navigate('/admin-space/list-post');
            }).catch((error) => {
                alert(error);
            }) : await addDoc(collection(db, 'blog-data'), {
                title: textValue,
                description: editorValue,
                isDraft
            }).then(() => {
                navigate('/admin-space/list-post');
            }).catch((error) => {
                alert(error);
            });
        } else {
            alert('Both fields are required');
        }
    };

    const RenderForm = () => {
        return (
            <form className='w-100' onSubmit={handleOnSubmit}>
                <div className='save-btn-wrapper'>
                    <button id='save' type='submit' className='login-btn'>
                        SAVE
                    </button>
                    <button id='saveAsDraft' style={{ marginLeft: '1em' }} type='submit' className='login-btn'>
                        SAVE as Draft
                    </button>
                </div>
                <div>
                    <EditorTextInput value={uuid ? postDetail.title : ''} />
                </div>
                <div>
                    <label htmlFor='blog-description'>Description</label>
                    <br />
                    <MarkdownEditor value={uuid ? postDetail.description : ''} />
                </div>
            </form>
        );
    };

    return (
        <div className='editor-container'>
            {loadingPostDetail ? <Loader /> : <RenderForm />}
        </div>
    );
};
